/*global $*/
/*eslint no-undef: "error"*/
export default class MenuMobile {
	classBlock = 'menu-mobile--block'
	classItem = 'menu-mobile--item'
	classButton = 'menu-mobile--button'
	classReset = 'menu-mobile--reset'


	classBack = 'menu-mobile---back'
	classActive = 'menu-mobile__item---active'


	constructor() {
		let self = this

		$(`.${self.classButton}`).click(function () {
			$(this).closest(`.${self.classBlock}`).addClass(self.classBack)
			$(this).closest(`.${self.classItem}`).addClass(self.classActive)
		})

		$(`.${self.classReset}`).click(function () {
			$(this).closest(`.${self.classBlock}`).removeClass(self.classBack)
			$(this).closest(`.${self.classBlock}`).find(`.${self.classItem}`).removeClass(self.classActive)
		})
	}
}
